var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlob6639555(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 800 500",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    id: "blobSvg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(195, 52)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(2, 56, 115)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(0, 43, 89)"
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10000ms",
    repeatCount: "indefinite",
    values: "M398,318.5Q329,387,248.5,390Q168,393,114,321.5Q60,250,101.5,157.5Q143,65,237.5,87Q332,109,399.5,179.5Q467,250,398,318.5Z;        M423.5,350.5Q366,451,255,442Q144,433,80.5,341.5Q17,250,88.5,172Q160,94,252,90.5Q344,87,412.5,168.5Q481,250,423.5,350.5Z;       M381.5,320Q331,390,249,391.5Q167,393,98.5,321.5Q30,250,83,151Q136,52,231,85.5Q326,119,379,184.5Q432,250,381.5,320Z;       M397,349.5Q365,449,250,449.5Q135,450,101,350Q67,250,103.5,154.5Q140,59,240,76.5Q340,94,384.5,172Q429,250,397,349.5Z;       M398,318.5Q329,387,248.5,390Q168,393,114,321.5Q60,250,101.5,157.5Q143,65,237.5,87Q332,109,399.5,179.5Q467,250,398,318.5Z;"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob6639555);
export default __webpack_public_path__ + "static/media/blob_6-6-39555.7c78fe10a0db009480f35de25e230c6e.svg";
export { ForwardRef as ReactComponent };